import { Button } from 'src/components/button';
import { DialogWrapper } from 'src/modules/network-configuration/dialog/shared/dialog-wrapper';

interface FeGeConnectionNoticeDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function FeGeConnectionNoticeDialog({
  open,
  onConfirm,
  onCancel,
}: FeGeConnectionNoticeDialogProps) {
  if (!open) return null;

  return (
    <DialogWrapper
      title="Notice"
      onClose={onCancel}
      testId="fe-ge-connection-notice-dialog"
      disableClickOutside
      footer={
        <div className="flex justify-end gap-2">
          <Button
            data-testid="fe-ge-connection-notice-dialog-cancel-button"
            color="gray"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            data-testid="fe-ge-connection-notice-dialog-ok-button"
            color="blue"
            onClick={onConfirm}
          >
            OK
          </Button>
        </div>
      }
    >
      <p className="text-sm text-gray-700">
        You are connecting a Fast Ethernet port (M12 d-coded) to a Gigabit
        Ethernet port (M12 x-coded)
      </p>
    </DialogWrapper>
  );
}
